import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
//项目文件
import './assets/js/rem'    //px转rem
import './assets/css/public.less'   //公共css
import "@/assets/iconfont/iconfont.css"     //公共字体

const app = createApp(App)
app.use(store)
app.use(router)
app.use(Antd)
app.mount('#app')
